/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：954
 */

module.exports = "\t\n\u000b\f\r                　  ﻿"
